<div class="legacy-dialog-header" mat-dialog-title>
		<div class="legacy-dialog-header-title">Steeluser</div>
		<div class="legacy-dialog-header-subtitle">
			<span translate>confirm-password-legacy.lost-password</span>
			<button type="button" (click)="closeDialog()">x</button>
		</div>
	</div>
<div class="legacy-dialog-body" mat-dialog-content *ngIf="infoStatus">
	<div [ngSwitch]="infoStatus">
		<div translate>
			<ng-container *ngSwitchCase="'lost_password_email_sent'">confirm-password-legacy.lost-password-email-sent</ng-container>
		</div>
	</div>
</div>
